import axios from 'axios'
import {ALTERAR_ITINERARIO} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function alterarTrecho(itinerario) {
    const url = `${URL}/itinerario/alterar`;
    return dispatch => axios.post(url, itinerario, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: ALTERAR_ITINERARIO,
            payload: response
        })
    );
}
